"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Arrival = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Arrival = function Arrival(_ref) {
  var scheduledTimeOfArrival = _ref.scheduledTimeOfArrival,
      realTimeOfArrival = _ref.realTimeOfArrival,
      estimatedTimeOfArrival = _ref.estimatedTimeOfArrival,
      timeZone = _ref.timeZone,
      earlyTolerance = _ref.earlyTolerance,
      lateTolerance = _ref.lateTolerance;
  // arrival values
  var deviationDuration;
  var deviationClassName = 'deviation-yellow';
  var sign = '+';
  var realArrival = realTimeOfArrival || estimatedTimeOfArrival;

  if (realArrival && scheduledTimeOfArrival) {
    var arrivalDate = new Date(realArrival);
    arrivalDate.setSeconds(0);
    arrivalDate.setMilliseconds(0);
    var scheduledDate = new Date(scheduledTimeOfArrival);
    scheduledDate.setSeconds(0);
    scheduledDate.setMilliseconds(0);
    var arrivalDeviation = (arrivalDate.getTime() - scheduledDate.getTime()) / 60000;
    deviationDuration = (0, _constants.splitDuration)(Math.abs(arrivalDeviation));
    var deviationAndSign = (0, _constants.getDeviationColourAndSign)(arrivalDeviation, earlyTolerance, lateTolerance);
    sign = deviationAndSign.sign;
    deviationClassName = "deviation-".concat(deviationAndSign.deviationColour);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "block"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.arrival"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-title"
    }, message);
  }), scheduledTimeOfArrival && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.target"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), scheduledTimeOfArrival && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: scheduledTimeOfArrival,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: timeZone
  })), realTimeOfArrival && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.actual"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), realTimeOfArrival && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: realTimeOfArrival,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: timeZone
  })), !realTimeOfArrival && estimatedTimeOfArrival && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.calculated"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), !realTimeOfArrival && estimatedTimeOfArrival && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: estimatedTimeOfArrival,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: timeZone
  })), deviationDuration && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.difference"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), deviationDuration && /*#__PURE__*/_react["default"].createElement("span", {
    className: deviationClassName
  }, sign, deviationDuration.hours, "h ", deviationDuration.minutes, "min"));
};

exports.Arrival = Arrival;
Arrival.propTypes = {
  scheduledTimeOfArrival: _propTypes["default"].string,
  realTimeOfArrival: _propTypes["default"].string,
  estimatedTimeOfArrival: _propTypes["default"].string,
  earlyTolerance: _propTypes["default"].number,
  lateTolerance: _propTypes["default"].number,
  timeZone: _propTypes["default"].string.isRequired
};
Arrival.defaultProps = {
  scheduledTimeOfArrival: null,
  realTimeOfArrival: null,
  earlyTolerance: 2000000,
  lateTolerance: 2000000,
  estimatedTimeOfArrival: null
};
var _default = Arrival;
exports["default"] = _default;